export const SharedConfigsTestIds = {
  // Address fields (dynamic, prefix-based)
  getIsNonUsAddressId: prefix => `${prefix}.is-non-us-address-checkbox`,
  getStreetId: prefix => `${prefix}.street-input`,
  getUnitId: prefix => `${prefix}.unit-input`,
  getCityId: prefix => `${prefix}.city-input`,
  getCountyId: prefix => `${prefix}.county-select`,
  getStateId: prefix => `${prefix}.state-select`,
  getZipId: prefix => `${prefix}.zip-input`,
  getCountryId: prefix => `${prefix}.country-select`,
  getCensusTractId: prefix => `${prefix}.census-tract-input`,

  // Property mortgage fields (dynamic, index-based)
  getLiabilityLinkedToPropertyId: index =>
    `property-mortgage-${index}.liability-linked-to-property-checkbox`,
  getMortgageOnThePropertyId: index => `property-mortgage-${index}.mortgage-on-the-property`,
  getMortgageLiabilityId: index => `property-mortgage-${index}.mortgage-liability-select`,
  getUnpaidBalanceId: index => `property-mortgage-${index}.unpaid-balance-input`,
  getAmountOfThePaymentId: index => `property-mortgage-${index}.amount-of-the-payment-input`,
  getHighLimitId: index => `property-mortgage-${index}.high-limit-input`,
};
